module.exports = __webpack_public_path__ + "img/bonus_phone_th.ba7413cf.png";